import { render, staticRenderFns } from "./PInputRequestArea.vue?vue&type=template&id=17a57d4c&scoped=true&"
import script from "./PInputRequestArea.vue?vue&type=script&lang=ts&"
export * from "./PInputRequestArea.vue?vue&type=script&lang=ts&"
import style0 from "./PInputRequestArea.vue?vue&type=style&index=0&id=17a57d4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a57d4c",
  null
  
)

export default component.exports